import { Autocomplete, TextField } from 'components/mui';
import { array, func } from 'prop-types';
import { Contact } from '../../constants/contact';
import * as TY from 'containers/pages/contacts/constants';

/**
 * @component SelectLanguages
 * @param {Object} props
 * @param {Language[]} props.value
 * @param {Language[]} props.options
 * @param {function} props.dispatch
 * @returns {JSX.Element}
 */
function SelectLanguages({ value = [], dispatch, options }) {
	const onChange = (e, newValues) => {
		dispatch({ type: TY.LANGUAGES, payload: newValues });
	};

	return (
		<Autocomplete
			multiple
			value={value}
			options={options}
			getOptionLabel={(option) => option.name}
			onChange={onChange}
			renderInput={(params) => (
				<TextField
					{...params}
					variant="outlined"
					label="Select Languages"
					InputLabelProps={{ shrink: true }}
				/>
			)}
		/>
	);
}

SelectLanguages.propTypes = {
	value: array,
	dispatch: func,
	options: array,
};

export default SelectLanguages;
